import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/solid/document-fill.svg'
import _imports_1 from '@/assets/icons/solid/image-fill.svg'
import _imports_2 from '@/assets/icons/solid/download-fill.svg'
import _imports_3 from '@/assets/icons/solid/video-fill.svg'


const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "mt-6" }
const _hoisted_4 = { class: "section-title mt-4" }
const _hoisted_5 = { class: "grid grid-cols-4 gap-4 w-3/4 mt-1" }
const _hoisted_6 = { class: "col-span-1" }
const _hoisted_7 = { class: "col-span-1" }
const _hoisted_8 = { class: "col-span-1" }
const _hoisted_9 = { class: "col-span-1 mt-5" }
const _hoisted_10 = { class: "font-medium" }
const _hoisted_11 = { class: "section-title mt-12" }
const _hoisted_12 = { class: "grid grid-cols-3 gap-4 mt-1" }
const _hoisted_13 = { class: "border-r-2" }
const _hoisted_14 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_15 = { class: "grid grid-cols-3 mt-6" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 1,
  class: "mt-5"
}
const _hoisted_18 = { class: "font-medium" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "grid grid-cols-2 text-right m-auto border-r-2 mt-0" }
const _hoisted_22 = { class: "grid grid-cols-1 gap-4" }
const _hoisted_23 = { class: "grid grid-cols-3 gap-4 mt-4" }
const _hoisted_24 = { class: "grid grid-cols-2 gap-4 mt-4" }
const _hoisted_25 = ["href"]
const _hoisted_26 = {
  key: 0,
  class: "flex bg-gray-100 border-2 border-gray-200 w-full h-24 m-auto text-brand-500 rounded-md"
}
const _hoisted_27 = ["src"]
const _hoisted_28 = {
  key: 1,
  class: "flex bg-gray-100 border-2 border-gray-200 w-full h-24 m-auto text-brand-500 rounded-md"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("img", {
  class: "linked-icon w-12 m-auto",
  src: _imports_0,
  alt: "document icon"
}, null, -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = { class: "text-gray-900 font-medium mt-2" }
const _hoisted_32 = { class: "text-sm" }
const _hoisted_33 = { class: "mt-6" }
const _hoisted_34 = {
  key: 0,
  class: "w-96 h-75 rounded-md bg-gray-300 animate-pulse"
}
const _hoisted_35 = ["src"]
const _hoisted_36 = {
  key: 2,
  class: "flex justify-center items-center object-cover w-96 h-75 rounded-md bg-gray-300"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("img", {
  class: "grayed-icon h-10 w-10",
  src: _imports_1,
  alt: "picture icon"
}, null, -1)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { class: "mt-6" }
const _hoisted_41 = ["href"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("img", {
  class: "linked-icon h-6 w-6",
  src: _imports_2,
  alt: "download icon"
}, null, -1)
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = { key: 2 }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]

import { // api
		getRoleDetailsByRecordId
	} from '../../../queries'

	import RoleCovidRestrictions from './RoleCovidRestrictions.vue' // components

	import { // languages
		useI18n
	} from 'vue-i18n'

	import { // store
		localesStore
	} from '@/store/locales'

	import { 
		store as userStore
	} from '@/store/user'

	import { // vue
		inject,
		onMounted,
		ref, 
		computed
	} from 'vue'

	interface tab {
		current: boolean,
		name: string
	}
	
	const __default__ = { name: 'RoleDetails' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		openToTab: {
			type: Number,
			default: 0
		},
		showInstructions:{
			type: Function,
			default: () => {return}
		},
		role: {
			type: Object,
			default: () => {return {}}
		}
	},
  setup(__props) {

	const props = __props

	const _localesStore = localesStore()
	const _userStore = userStore()

	const {t} = useI18n()

	const tabs = ref<tab[]>()

	if(_userStore.getContactType === 'Staff') {		
		if(showCovidRestrictions()) {
			tabs.value = [
				{ name: _localesStore.getLabel('278'), current: false }, // COVID Restrictions
				{ name: _localesStore.getLabel('685') + " / " + _localesStore.getLabel('185'), current: false }, // Hotel and Transportation
				{ name: _localesStore.getLabel('293'), current: false },  // Picture
				{ name: _localesStore.getLabel('205') + " / " + _localesStore.getLabel('203'), current: false }, // Notes and Documents
				{ name: _localesStore.getLabel('181'), current: false }  // Instructions
			]
		}
		else{
			tabs.value =  [
				{ name: _localesStore.getLabel('293'), current: false },  // Picture
			]
		}
	} 
	else 
	{
		tabs.value =  [
			{ name: _localesStore.getLabel('278'), current: false }, // COVID Restrictions
			{ name: _localesStore.getLabel('293'), current: false },  // Picture
		]
	}

	function showCovidRestrictions() {
		if(_userStore.getContactType === 'Staff') {
			return props.role?.['job__JOBS_ROLES__liveJobID_gStaffID::_kf_contacts_id'] === _userStore.user.contactId ||
				props.role?.['job__JOBS_ROLES__instrumentalJobID_gStaffID::_kf_contacts_id'] === _userStore.user.contactId ||
				props.role?.['job__JOBS_ROLES__standardJobID_gStaffID::_kf_contacts_id'] === _userStore.user.contactId
		}else{
			return true
		}
	}

	const childTabs = ref<{_tabs: []}>({_tabs: []})

	const instructionsList = ref()
	const documentList = ref()
	const taxDocuments = ref()
	const transportationMultiple = ref([])
	const transportationEmergency = ref([])
	
	const loading = ref(true)
	const loadingTaxDocuments = ref(true)
	const loadingRoleDocuments = ref(true)
	const s3: any = inject('s3')
	const fetchS3File: any = inject('fetchS3File')
	const signedUrl = ref('')

	onMounted(async () => {
		loading.value = true

		// set active tab
		tabs.value[props.openToTab].current = true

		try { // fetching role details
			if(props.role?.['job__JOBS_ROLES__instrumentalJobID_gStaffID::_kf_contacts_id'] === _userStore.user.contactId) {
				const scriptParams = JSON.stringify({
					language: _localesStore.getFmLanguage,
				})

				const params = `?script.prerequest=${encodeURI("Set Language")}&script.prerequest.param=${encodeURI(scriptParams)}`
				let res = await getRoleDetailsByRecordId(props?.role?.recordId, params)
				const record = res.response.data[0]

				instructionsList.value = record.portalData.jobs_roles__INSTRUCTIONS_JOIN_JOBS__jobsRolesID
				documentList.value = record.portalData.jobs_roles__DOCUMENTS__jobsRolesID
				taxDocuments.value = record.portalData.jobs_roles__DOCUMENTS__jobsRolesTaxesID
				transportationMultiple.value = record.portalData.jobs_roles__TRANSPORTATION__multipleID
				transportationEmergency.value = record.portalData.jobs_roles__TRANSPORTATION__jobsRolesID
			}
		}
		catch(e) {
			console.log(e)
		}

		try { // loading image from s3
			const s3Json = props.role?.['job__job_role__CONTACTS_ROLES__contactRoleID_standard_gStaffID::s3JSONPicture'] || 
				props.role?.['job__job_role__CONTACTS_ROLES__contactRoleID_instrumental_gStaffID::s3JSONPicture'] ||
				props.role?.['job__job_role__CONTACTS_ROLES__contactRoleID_live_gStaffID::s3JSONPicture'] || 
				props.role?.['job__job_role__CONTACTS_ROLES__contactRoleID_standard::s3JSONPicture'] || 
				props.role?.['job__job_role__CONTACTS_ROLES__contactRoleID_instrumental::s3JSONPicture'] ||
				props.role?.['job__job_role__CONTACTS_ROLES__contactRoleID_live::s3JSONPicture']
			signedUrl.value = await fetchS3File(s3Json)
		}
		catch(e) {
			console.log(e)
		}
		finally {
			loading.value = false
		}

		fetchTaxDocuments()
		fetchRoleDocuments()
	})

	function fetchTaxDocuments() {
		try { // fetching tax document files from s3
			loadingRoleDocuments.value = true
			taxDocuments.value?.forEach((document: any) => {
				const documentS3Json = JSON.parse(document?.["jobs_roles__DOCUMENTS__jobsRolesTaxesID::s3JSONDocument"] || "{}")
				const documentKey = documentS3Json?.s3FilePathShortRaw
				const ext = documentS3Json?.fileExt
				document.ext = ext

				if(documentKey) {
					let params = {
						Bucket: process.env.VUE_APP_S3_BUCKET,
						Key: documentKey
					}
		
					s3.getSignedUrlPromise('getObject', params).then(
						function (url: string) {
							document.signedUrl = url
						}, 
						function (err: Error) { 
							throw err
						}
					)
				}
			})
		}
		catch(e) {
			console.error(e)
		}
		finally {
			loadingRoleDocuments.value = false
		}
	}

	function fetchRoleDocuments() {
		try { // fetching role document files from s3
			loadingTaxDocuments.value = true
			documentList.value?.forEach((document: any) => {
				const documentS3Json = JSON.parse(document?.["jobs_roles__DOCUMENTS__jobsRolesID::s3JSONDocument"] || "{}")
				const documentKey = documentS3Json?.s3FilePathShortRaw
				const ext = documentS3Json?.fileExt
				document.ext = ext

				if(documentKey) {
					let params = {
						Bucket: process.env.VUE_APP_S3_BUCKET,
						Key: documentKey
					}
		
					s3.getSignedUrlPromise('getObject', params).then(
						function (url: string) {
							document.signedUrl = url
						}, 
						function (err: Error) { 
							throw err
						}
					)
				}
			})
		}
		catch(e) {
			console.error(e)
		}
		finally {
			loadingTaxDocuments.value = false
		}
	}

	const transportationType = computed(() => {
		return emergencyTransportation.value ? _localesStore.getLabel('684') : props.role?.["job_jobs_roles__TRANSPORTATION__gStaffID_instrumental_transportationID::type_display"] || 
			props.role?.["job_jobs_roles__TRANSPORTATION__gStaffID_standard_transportationID::type_display"] || 
			props.role?.["job_jobs_roles__TRANSPORTATION__gStaffID_live_transportationID::type_display"]
	})

	const transportationCost = computed(() => {
		return props.role?.["job__JOBS_ROLES__instrumentalJobID_gStaffID::cost_transportation"] || 
			props.role?.["job__JOBS_ROLES__standardJobID_gStaffID::cost_transportation"] || 
			props.role?.["job__JOBS_ROLES__liveJobID_gStaffID::cost_transportation"] ||
			props.role?.["job__JOBS_ROLES__instrumentalJobID_gStaffID::cost_emergency"] || 
			props.role?.["job__JOBS_ROLES__standardJobID_gStaffID::cost_emergency"] || 
			props.role?.["job__JOBS_ROLES__liveJobID_gStaffID::cost_emergency"]
	})

	const time = computed(() => {
		if(props.role?.["job_jobs_roles__TRANSPORTATION__gStaffID_instrumental_transportationID::type_display"] === 'Multiple' || 
			props.role?.["job_jobs_roles__TRANSPORTATION__gStaffID_standard_transportationID::type_display"] === 'Multiple' || 
			props.role?.["job_jobs_roles__TRANSPORTATION__gStaffID_live_transportationID::type_display"] === 'Multiple') {

			return props.role?.["job_jobs_roles__TRANSPORTATION__gStaffID_instrumental_transportationID::time_multiple"] || 
				props.role?.["job_jobs_roles__TRANSPORTATION__gStaffID_standard_transportationID::time_multiple"] || 
				props.role?.["job_jobs_roles__TRANSPORTATION__gStaffID_live_transportationID::time_multiple"]
		}
		else {
			return props.role?.["job__JOBS_ROLES__instrumentalJobID_gStaffID::time"] || 
				props.role?.["job__JOBS_ROLES__standardJobID_gStaffID::time"] || 
				props.role?.["job__JOBS_ROLES__liveJobID_gStaffID::time"] ||
				props.role?.["job__JOBS_ROLES__instrumentalJobID_gStaffID::time_emergency"] || 
				props.role?.["job__JOBS_ROLES__standardJobID_gStaffID::time_emergency"] || 
				props.role?.["job__JOBS_ROLES__liveJobID_gStaffID::time_emergency"]
				
		}
	})

	const agreement = computed(() => {
		return props.role?.["job__JOBS_ROLES__instrumentalJobID_gStaffID::date_last_checked"] ??
			props.role?.["job__JOBS_ROLES__standardJobID_gStaffID::date_last_checked"] ??
			props.role?.["job__JOBS_ROLES__liveJobID_gStaffID::date_last_checked"]
	})

	const primary = computed(() => {
		return props.role?.["job__JOBS_ROLES__instrumentalJobID_gStaffID::primary"] ??
			props.role?.["job__JOBS_ROLES__standardJobID_gStaffID::primary"] ??
			props.role?.["job__JOBS_ROLES__liveJobID_gStaffID::primary"]
	})

	const emergencyTransportation = computed(() => {
		return props.role?.["job__JOBS_ROLES__instrumentalJobID_gStaffID::emergency_transport"] ??
			props.role?.["job__JOBS_ROLES__standardJobID_gStaffID::emergency_transport"] ??
			props.role?.["job__JOBS_ROLES__liveJobID_gStaffID::emergency_transport"]
	})

	const roleCost = computed(() => {
		return props.role?.["job__JOBS_ROLES__instrumentalJobID_gStaffID::role_cost"] ??
			props.role?.["job__JOBS_ROLES__standardJobID_gStaffID::role_cost"] ??
			props.role?.["job__JOBS_ROLES__liveJobID_gStaffID::role_cost"]
	})

	const other1 = computed(() => {
		if(props.role?.["job__JOBS_ROLES__instrumentalJobID_gStaffID::other1_withholding"] || 
			props.role?.["job__JOBS_ROLES__standardJobID_gStaffID::other1_withholding"] || 
			props.role?.["job__JOBS_ROLES__liveJobID_gStaffID::other1_withholding"]) {

			return props.role?.["job__JOBS_ROLES__instrumentalJobID_gStaffID::other1_withholding"] ??
				props.role?.["job__JOBS_ROLES__standardJobID_gStaffID::other1_withholding"] ??
				props.role?.["job__JOBS_ROLES__liveJobID_gStaffID::other1_withholding"]
		}else{
			return null
		}		
	})

	const other2 = computed(() => {
		return props.role?.["job__JOBS_ROLES__instrumentalJobID_gStaffID::other2_withholding_total"] ??
			props.role?.["job__JOBS_ROLES__standardJobID_gStaffID::other2_withholding_total"] ??
			props.role?.["job__JOBS_ROLES__liveJobID_gStaffID::other2_withholding_total"]
	})

	const totalBeforeTaxes = computed(() => {
		return props.role?.["job__JOBS_ROLES__instrumentalJobID_gStaffID::total_before_tax"] ??
			props.role?.["job__JOBS_ROLES__standardJobID_gStaffID::total_before_tax"] ??
			props.role?.["job__JOBS_ROLES__liveJobID_gStaffID::total_before_tax"]
	})

	const consumptionTax = computed(() => {
		return props.role?.["job__JOBS_ROLES__instrumentalJobID_gStaffID::consumption_withholding"] ??
			props.role?.["job__JOBS_ROLES__standardJobID_gStaffID::consumption_withholding"] ??
			props.role?.["job__JOBS_ROLES__liveJobID_gStaffID::consumption_withholding"]
	})

	const totalBeforeWithholding = computed(() => {
		return props.role?.["job__JOBS_ROLES__instrumentalJobID_gStaffID::total_before_taxes_witholding"] ??
			props.role?.["job__JOBS_ROLES__standardJobID_gStaffID::total_before_taxes_witholding"] ??
			props.role?.["job__JOBS_ROLES__liveJobID_gStaffID::total_before_taxes_witholding"]
	})

	const withholdingTax = computed(() => {
		return props.role?.["job__JOBS_ROLES__instrumentalJobID_gStaffID::withholding_amount"] ??
			props.role?.["job__JOBS_ROLES__standardJobID_gStaffID::withholding_anmount"] ??
			props.role?.["job__JOBS_ROLES__liveJobID_gStaffID::withholding_amount"]
	})

	const subtotal = computed(() => {
		return props.role?.["job__JOBS_ROLES__standardJobID_gStaffID::subtotal_withholding"] ??
			props.role?.["job__JOBS_ROLES__instrumentalJobID_gStaffID::subtotal_withholding"] ??
			props.role?.["job__JOBS_ROLES__liveJobID_gStaffID::subtotal_withholding"]
	})

	const grandTotal = computed(() => {
		return props.role?.["job__JOBS_ROLES__instrumentalJobID_gStaffID::grand_total_withholding"] ??
			props.role?.["job__JOBS_ROLES__standardJobID_gStaffID::grand_total_withholding"] ??
			props.role?.["job__JOBS_ROLES__liveJobID_gStaffID::grand_total_withholding"]
	})

	const memo1 = computed(() => {
		return props.role?.["job__JOBS_ROLES__instrumentalJobID_gStaffID::memo_display_other1"] ??
			props.role?.["job__JOBS_ROLES__standardJobID_gStaffID::memo_display_other1"] ??
			props.role?.["job__JOBS_ROLES__liveJobID_gStaffID::memo_display_other1"]
	})

	const memo2 = computed(() => {
		return props.role?.["job__JOBS_ROLES__instrumentalJobID_gStaffID::memo_display_other2"] ??
			props.role?.["job__JOBS_ROLES__instrumentalJobID_gStaffID::memo_display_other2"] ??
			props.role?.["job__JOBS_ROLES__instrumentalJobID_gStaffID::memo_display_other2"]
	})

	const hotelName = computed(() => {
		return props.role?.["job__JOBS_ROLES__instrumentalJobID_gStaffID::hotel_name"] ??
			props.role?.["job__JOBS_ROLES__liveJobID_gStaffID::hotel_name"] ??
			props.role?.["job__JOBS_ROLES__standardJobID_gStaffID::hotel_name"]
	})

	const hotelAddress = computed(() => {
		return props.role?.["job__JOBS_ROLES__instrumentalJobID_gStaffID::hotel_address"] ??
			props.role?.["job__JOBS_ROLES__liveJobID_gStaffID::hotel_address"] ??
			props.role?.["job__JOBS_ROLES__standardJobID_gStaffID::hotel_address"]
	})

	const hotelPhone = computed(() => {
		return props.role?.["job__JOBS_ROLES__instrumentalJobID_gStaffID::hotel_phone"] ??
			props.role?.["job__JOBS_ROLES__liveJobID_gStaffID::hotel_phone"] ??
			props.role?.["job__JOBS_ROLES__standardJobID_gStaffID::hotel_phone"]
	})

	const hotelPayment = computed(() => {
		if(props.role?.["job__JOBS_ROLES__instrumentalJobID_gStaffID::hotel_payment"] || 
			props.role?.["job__JOBS_ROLES__liveJobID_gStaffID::hotel_payment"] || 
			props.role?.["job__JOBS_ROLES__standardJobID_gStaffID::hotel_payment"]) {

			return props.role?.["job__JOBS_ROLES__instrumentalJobID_gStaffID::hotel_payment"] ??
				props.role?.["job__JOBS_ROLES__liveJobID_gStaffID::hotel_payment"] ??
				props.role?.["job__JOBS_ROLES__standardJobID_gStaffID::hotel_payment"]
		}
		else{
			return null
		}
	})

	const notes = computed(() => {
		return props.role?.["job__JOBS_ROLES__instrumentalJobID_gStaffID::notes_display"] || 
			props.role?.["job__JOBS_ROLES__liveJobID_gStaffID::notes_display"] || 
			props.role?.["job__JOBS_ROLES__standardJobID_gStaffID::notes_display"]
	})

	const other2AdditionalHotel = computed(() => {
		return props.role?.["job__JOBS_ROLES__instrumentalJobID_gStaffID::hotel"] || 
			props.role?.["job__JOBS_ROLES__liveJobID_gStaffID::hotel"] || 
			props.role?.["job__JOBS_ROLES__standardJobID_gStaffID::hotel"]
	})

	const other2AdditionalMeals = computed(() => {
		return props.role?.["job__JOBS_ROLES__instrumentalJobID_gStaffID::meals"] || 
			props.role?.["job__JOBS_ROLES__standardJobID_gStaffID::meals"] || 
			props.role?.["job__JOBS_ROLES__liveJobID_gStaffID::meals"]
	})

	const other2AdditionalOther = computed(() => {
		return props.role?.["job__JOBS_ROLES__instrumentalJobID_gStaffID::other2_withholding"] || 
			props.role?.["job__JOBS_ROLES__standardJobID_gStaffID::other2_withholding"] || 
			props.role?.["job__JOBS_ROLES__liveJobID_gStaffID::other2_withholding"]
	})

	function hasPicture(row: any) {
		return row?.['jobs_roles__instructions_join_jobs__INSTRUCTIONS_JOIN__instructionsJoinID::s3JSONPicture']
	}

	function hasVideo(row: any) {
		return row?.['jobs_roles__instructions_join_jobs__INSTRUCTIONS_JOIN__instructionsJoinID::s3JSONVideo']
	}

return (_ctx: any,_cache: any) => {
  const _component_tw_tabs_underline = _resolveComponent("tw-tabs-underline")!
  const _component_data_display = _resolveComponent("data-display")!
  const _component_CheckIconMini = _resolveComponent("CheckIconMini")!
  const _component_MinusIconMini = _resolveComponent("MinusIconMini")!
  const _component_tw_table_column = _resolveComponent("tw-table-column")!
  const _component_tw_table = _resolveComponent("tw-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_tw_tabs_underline, {
        ref_key: "childTabs",
        ref: childTabs,
        tabs: tabs.value
      }, null, 8, ["tabs"])
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(RoleCovidRestrictions, { role: __props.role }, null, 8, ["role"])
      ])
    ], 512), [
      [_vShow, childTabs.value?._tabs?.[showCovidRestrictions() ? 0 : 5]?.current]
    ]),
    (_unref(_userStore).getContactType === 'Staff' && showCovidRestrictions() )
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(_localesStore).getLabel('685')), 1),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_data_display, {
                  label: _unref(_localesStore).getLabel('149'),
                  value: hotelName.value
                }, null, 8, ["label", "value"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_data_display, {
                  label: _unref(_localesStore).getLabel('5'),
                  value: hotelAddress.value
                }, null, 8, ["label", "value"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_data_display, {
                  label: _unref(_localesStore).getLabel('561'),
                  value: hotelPhone.value
                }, null, 8, ["label", "value"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", {
                  class: _normalizeClass(["flex justify-start gap-2 items-center", {'opacity-30': !hotelPayment.value}])
                }, [
                  (hotelPayment.value)
                    ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                        key: 0,
                        class: "h-5 w-5"
                      }))
                    : (_openBlock(), _createBlock(_component_MinusIconMini, {
                        key: 1,
                        class: "h-5 w-5"
                      })),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(_localesStore).getLabel('448')), 1)
                ], 2)
              ])
            ]),
            _createElementVNode("h2", _hoisted_11, _toDisplayString(_unref(_localesStore).getLabel('185')), 1),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_data_display, {
                      label: _unref(_localesStore).getLabel('185'),
                      value: transportationType.value
                    }, null, 8, ["label", "value"])
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_data_display, {
                      label: _unref(_localesStore).getLabel('45'),
                      value: transportationCost.value || transportationCost.value === 0 ? '¥' + transportationCost.value : null
                    }, null, 8, ["label", "value"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_data_display, {
                      label: _unref(_localesStore).getLabel('332'),
                      value: _ctx.$filters.timeDuration(time.value)
                    }, null, 8, ["label", "value"])
                  ]),
                  (!transportationType.value?.includes('Emergency'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createVNode(_component_data_display, {
                          label: _unref(_localesStore).getLabel('32'),
                          value: agreement.value
                        }, null, 8, ["label", "value"])
                      ]))
                    : _createCommentVNode("", true),
                  (!transportationType.value?.includes('Emergency'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["flex justify-start gap-2 items-center", {'opacity-30': !primary.value}])
                        }, [
                          (primary.value)
                            ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                                key: 0,
                                class: "h-5 w-5"
                              }))
                            : (_openBlock(), _createBlock(_component_MinusIconMini, {
                                key: 1,
                                class: "h-5 w-5"
                              })),
                          _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(_localesStore).getLabel('292')), 1)
                        ], 2)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (transportationMultiple.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createVNode(_component_tw_table, { data: transportationMultiple.value }, {
                        default: _withCtx(() => [
                          _createVNode(_component_tw_table_column, {
                            header: _unref(_localesStore).getLabel('1')
                          }, {
                            default: _withCtx(({row}) => [
                              _createTextVNode(_toDisplayString(row["jobs_roles__TRANSPORTATION__multipleID::type_display"]), 1)
                            ]),
                            _: 1
                          }, 8, ["header"]),
                          _createVNode(_component_tw_table_column, {
                            header: _unref(_localesStore).getLabel('229')
                          }, {
                            default: _withCtx(({row}) => [
                              _createTextVNode(" ¥" + _toDisplayString(row["jobs_roles__TRANSPORTATION__multipleID::cost"]), 1)
                            ]),
                            _: 1
                          }, 8, ["header"]),
                          _createVNode(_component_tw_table_column, {
                            header: _unref(_localesStore).getLabel('332')
                          }, {
                            default: _withCtx(({row}) => [
                              _createTextVNode(_toDisplayString(_ctx.$filters.timeDuration(row["jobs_roles__TRANSPORTATION__multipleID::time"])), 1)
                            ]),
                            _: 1
                          }, 8, ["header"])
                        ]),
                        _: 1
                      }, 8, ["data"])
                    ]))
                  : _createCommentVNode("", true),
                (transportationType.value.includes('Emergency') && transportationEmergency.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createVNode(_component_tw_table, { data: transportationEmergency.value }, {
                        default: _withCtx(() => [
                          _createVNode(_component_tw_table_column, {
                            header: _unref(_localesStore).getLabel('1')
                          }, {
                            default: _withCtx(({row}) => [
                              _createTextVNode(_toDisplayString(row["jobs_roles__TRANSPORTATION__jobsRolesID::type_display"]), 1)
                            ]),
                            _: 1
                          }, 8, ["header"]),
                          _createVNode(_component_tw_table_column, {
                            header: _unref(_localesStore).getLabel('229')
                          }, {
                            default: _withCtx(({row}) => [
                              _createTextVNode(" ¥" + _toDisplayString(row["jobs_roles__TRANSPORTATION__jobsRolesID::cost"]), 1)
                            ]),
                            _: 1
                          }, 8, ["header"]),
                          _createVNode(_component_tw_table_column, {
                            header: _unref(_localesStore).getLabel('332')
                          }, {
                            default: _withCtx(({row}) => [
                              _createTextVNode(_toDisplayString(_ctx.$filters.timeDuration(row["jobs_roles__TRANSPORTATION__jobsRolesID::time"])), 1)
                            ]),
                            _: 1
                          }, 8, ["header"])
                        ]),
                        _: 1
                      }, 8, ["data"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_data_display, {
                  label: _unref(_localesStore).getLabel('43'),
                  value: _ctx.$filters.jpy(roleCost.value),
                  "value-class": "text-right pr-18",
                  "label-class": "-ml-4"
                }, null, 8, ["label", "value"]),
                _createVNode(_component_data_display, {
                  label: _unref(_localesStore).getLabel('716') + ' (1)',
                  value: _ctx.$filters.jpy(other1.value),
                  "value-class": "text-right pr-18",
                  "label-class": "-ml-4"
                }, null, 8, ["label", "value"]),
                _createVNode(_component_data_display, {
                  label: _unref(_localesStore).getLabel('718'),
                  value: _ctx.$filters.jpy(totalBeforeTaxes.value),
                  "value-class": "text-right pr-18",
                  "label-class": "-ml-4"
                }, null, 8, ["label", "value"]),
                _createVNode(_component_data_display, {
                  label: _unref(_localesStore).getLabel('372'),
                  value: _ctx.$filters.jpy(consumptionTax.value),
                  "value-class": "text-right pr-18",
                  "label-class": "-ml-4"
                }, null, 8, ["label", "value"]),
                _createVNode(_component_data_display, {
                  label: _unref(_localesStore).getLabel('717'),
                  value: _ctx.$filters.jpy(totalBeforeWithholding.value),
                  "value-class": "text-right pr-18",
                  "label-class": "-ml-4"
                }, null, 8, ["label", "value"]),
                _createVNode(_component_data_display, {
                  label: _unref(_localesStore).getLabel('715'),
                  value: _ctx.$filters.jpy(withholdingTax.value),
                  "value-class": "text-right pr-18",
                  "label-class": "-ml-4"
                }, null, 8, ["label", "value"]),
                _createVNode(_component_data_display, {
                  label: _unref(_localesStore).getLabel('373'),
                  value: _ctx.$filters.jpy(subtotal.value),
                  "value-class": "text-right pr-18",
                  "label-class": "-ml-4"
                }, null, 8, ["label", "value"]),
                _createVNode(_component_data_display, {
                  label: _unref(_localesStore).getLabel('716') + ' (2)',
                  value: _ctx.$filters.jpy(other2.value),
                  "value-class": "text-right pr-18",
                  "label-class": "-ml-4"
                }, null, 8, ["label", "value"]),
                _createVNode(_component_data_display, {
                  label: _unref(_localesStore).getLabel('374'),
                  value: _ctx.$filters.jpy(grandTotal.value),
                  "value-class": "text-right pr-18",
                  "label-class": "-ml-4"
                }, null, 8, ["label", "value"])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_data_display, {
                      label: _unref(_localesStore).getLabel('726') + ' (1)',
                      value: memo1.value
                    }, null, 8, ["label", "value"])
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_data_display, {
                      label: _unref(_localesStore).getLabel('726') + ' (2)',
                      value: memo2.value
                    }, null, 8, ["label", "value"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_data_display, {
                      label: _unref(t)('roles.additionalHotel'),
                      value: other2AdditionalHotel.value || other2AdditionalHotel.value === 0 ? '¥' + other2AdditionalHotel.value : null
                    }, null, 8, ["label", "value"])
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_data_display, {
                      label: _unref(t)('roles.additionalMeal'),
                      value: other2AdditionalMeals.value || other2AdditionalMeals.value === 0 ? '¥' + other2AdditionalMeals.value : null
                    }, null, 8, ["label", "value"])
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_data_display, {
                      label: _unref(t)('roles.additionalOther'),
                      value: other2AdditionalOther.value || other2AdditionalOther.value === 0 ? '¥' + other2AdditionalOther.value : null
                    }, null, 8, ["label", "value"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(taxDocuments.value, (document) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: document.recordId
                    }, [
                      _createElementVNode("a", {
                        target: "_blank",
                        class: "w-full truncate hover:opacity-70",
                        href: document?.signedUrl,
                        download: ""
                      }, [
                        (document.ext == 'jpeg' || document.ext == 'jpg' || document.ext == 'png' || document.ext == 'gif')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                              _createElementVNode("img", {
                                src: document.signedUrl,
                                class: "w-full h-full object-cover rounded-md"
                              }, null, 8, _hoisted_27)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_30)),
                        _createElementVNode("div", _hoisted_31, _toDisplayString(document['jobs_roles__DOCUMENTS__jobsRolesTaxesID::name_display']), 1),
                        _createElementVNode("div", _hoisted_32, _toDisplayString(document['jobs_roles__DOCUMENTS__jobsRolesTaxesID::description_display']), 1)
                      ], 8, _hoisted_25)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ], 512)), [
          [_vShow, childTabs.value?._tabs?.[showCovidRestrictions() ? 1 : 5]?.current]
        ])
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_33, [
        _createVNode(_component_data_display, {
          label: _unref(_localesStore).getLabel('293')
        }, {
          custom: _withCtx(() => [
            (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34))
              : (signedUrl.value)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    class: "object-cover w-96 h-75 rounded-md",
                    src: signedUrl.value
                  }, null, 8, _hoisted_35))
                : (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_38))
          ]),
          _: 1
        }, 8, ["label"])
      ])
    ], 512), [
      [_vShow, childTabs.value?._tabs?.[_unref(_userStore).getContactType === 'Client' ? 1 : showCovidRestrictions() && _unref(_userStore).getContactType == 'Staff' ? 2 : 0]?.current]
    ]),
    (_unref(_userStore).getContactType === 'Staff')
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createVNode(_component_data_display, {
              label: _unref(_localesStore).getLabel('205'),
              value: notes.value
            }, null, 8, ["label", "value"])
          ]),
          _createVNode(_component_tw_table, {
            loading: loadingRoleDocuments.value,
            data: documentList.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_tw_table_column, {
                header: _unref(_localesStore).getLabel('202')
              }, {
                default: _withCtx(({row}) => [
                  _createTextVNode(_toDisplayString(row["jobs_roles__DOCUMENTS__jobsRolesID::name_display"]), 1)
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_tw_table_column, {
                header: _unref(_localesStore).getLabel('190')
              }, {
                default: _withCtx(({row}) => [
                  _createTextVNode(_toDisplayString(row["jobs_roles__DOCUMENTS__jobsRolesID::description_display"]), 1)
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_tw_table_column, {
                header: _unref(_localesStore).getLabel('445')
              }, {
                default: _withCtx(({row}) => [
                  _createTextVNode(_toDisplayString(row["jobs_roles__DOCUMENTS__jobsRolesID::stamp_create"]), 1)
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_tw_table_column, null, {
                default: _withCtx(({row}) => [
                  _createElementVNode("a", {
                    target: "_blank",
                    class: "cursor-pointer",
                    href: row?.signedUrl,
                    download: ""
                  }, _hoisted_43, 8, _hoisted_41)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["loading", "data"])
        ], 512)), [
          [_vShow, childTabs.value?._tabs?.[showCovidRestrictions() ? 3 : 5]?.current]
        ])
      : _createCommentVNode("", true),
    (_unref(_userStore).getContactType === 'Staff')
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_44, [
          _createVNode(_component_tw_table, {
            placeholder: _unref(t)('placeholders.noInstructions'),
            loading: loading.value,
            data: instructionsList.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_tw_table_column, {
                header: _unref(_localesStore).getLabel('149'),
                prop: "jobs_roles__instructions_join_jobs__INSTRUCTIONS__instructionsID::name_display"
              }, null, 8, ["header"]),
              _createVNode(_component_tw_table_column, {
                header: _unref(_localesStore).getLabel('181'),
                prop: "jobs_roles__instructions_join_jobs__INSTRUCTIONS_JOIN__instructionsJoinID::instructions_display_edit"
              }, null, 8, ["header"]),
              _createVNode(_component_tw_table_column, {
                "class-name": "w-6",
                "header-class-name": "w-6",
                "align-text": "right"
              }, {
                default: _withCtx(({row}) => [
                  _createElementVNode("div", {
                    class: "h-6 w-6 cursor-pointer",
                    onClick: ($event: any) => (__props.showInstructions(row))
                  }, [
                    _createElementVNode("img", {
                      class: _normalizeClass([hasPicture(row) ? 'linked-icon' : 'grayed-icon']),
                      src: _imports_1,
                      alt: "picture icon"
                    }, null, 2)
                  ], 8, _hoisted_45)
                ]),
                _: 1
              }),
              _createVNode(_component_tw_table_column, {
                "class-name": "w-6",
                "header-class-name": "w-6",
                "align-text": "right"
              }, {
                default: _withCtx(({row}) => [
                  _createElementVNode("div", {
                    class: "h-6 w-6 cursor-pointer",
                    onClick: ($event: any) => (__props.showInstructions(row))
                  }, [
                    _createElementVNode("img", {
                      class: _normalizeClass([hasVideo(row) ? 'linked-icon' : 'grayed-icon']),
                      src: _imports_3,
                      alt: "video icon"
                    }, null, 2)
                  ], 8, _hoisted_46)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["placeholder", "loading", "data"])
        ], 512)), [
          [_vShow, childTabs.value?._tabs?.[showCovidRestrictions() ? 4 : 5]?.current]
        ])
      : _createCommentVNode("", true)
  ]))
}
}

})